import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Dayjs } from 'dayjs';

interface TournamentDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tournamentName: string;
  onTournamentNameChange: (name: string) => void;
  tournamentDate: Dayjs | null;
  onTournamentDateChange: (date: Dayjs | null) => void;
}

const TournamentDialog: React.FC<TournamentDialogProps> = ({
  open,
  onClose,
  onConfirm,
  tournamentName,
  onTournamentNameChange,
  tournamentDate,
  onTournamentDateChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Tournament</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Tournament Name"
          fullWidth
          variant="outlined"
          value={tournamentName}
          onChange={(e) => onTournamentNameChange(e.target.value)}
          sx={{ mb: 2 }}
        />
        <DatePicker
          label="Tournament Date"
          value={tournamentDate}
          onChange={onTournamentDateChange}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained">
          Create Tournament
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TournamentDialog;
